import { useEffect, useState } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative h-screen w-full flex items-center justify-center overflow-hidden bg-neutral-900">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/4185a7ed610e75d736f4dab717ebea2f/72c22c004a1016c0ed0885f8808626f5.jpeg')`,
          filter: 'brightness(0.4)'
        }}
      />
      
      {/* Winter sparkle overlay */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-white rounded-full animate-pulse" style={{ animationDelay: '0s', animationDuration: '2s' }}></div>
        <div className="absolute top-1/3 right-1/4 w-1 h-1 bg-white rounded-full animate-pulse" style={{ animationDelay: '0.5s', animationDuration: '3s' }}></div>
        <div className="absolute bottom-1/3 left-1/3 w-1.5 h-1.5 bg-white rounded-full animate-pulse" style={{ animationDelay: '1s', animationDuration: '2.5s' }}></div>
        <div className="absolute top-1/2 right-1/3 w-1 h-1 bg-white rounded-full animate-pulse" style={{ animationDelay: '1.5s', animationDuration: '2s' }}></div>
        <div className="absolute bottom-1/4 right-1/5 w-2 h-2 bg-white rounded-full animate-pulse" style={{ animationDelay: '0.8s', animationDuration: '3s' }}></div>
        <div className="absolute top-2/3 left-1/5 w-1 h-1 bg-white rounded-full animate-pulse" style={{ animationDelay: '1.2s', animationDuration: '2.5s' }}></div>
      </div>
      
      <div className={`relative z-10 text-center px-6 transition-all duration-1500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="mb-8">
          <div className="text-neutral-300 text-xs md:text-sm tracking-[0.3em] uppercase mb-6 font-light">
            Studio Sang
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-7xl xl:text-8xl text-white mb-6 font-light tracking-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Thank You for<br />Our First Year.
          </h1>
          <p className="text-sm md:text-xl lg:text-2xl text-neutral-200 tracking-wide font-light">
            STUDIO SANG 고객 감사제
          </p>
        </div>
        
        <div className="mt-16">
          <button 
            onClick={() => document.getElementById('participation')?.scrollIntoView({ behavior: 'smooth' })}
            className="group relative inline-flex items-center gap-3 px-8 md:px-10 py-3 md:py-4 bg-white text-black text-xs md:text-sm tracking-[0.2em] uppercase font-medium transition-all duration-300 hover:bg-neutral-100 cursor-pointer whitespace-nowrap"
          >
            Discover More
            <i className="ri-arrow-down-line text-base md:text-lg transition-transform duration-300 group-hover:translate-y-1"></i>
          </button>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
